export default "__VITE_ASSET__BxJLpIPN__"